import {
  fetchAuthSession,
  fetchUserAttributes,
  signIn,
  signOut,
  getCurrentUser,
  signUp,
  confirmSignUp,
  resendSignUpCode,
} from "aws-amplify/auth";
import { generateClient } from "aws-amplify/data";
import outputs from "~~/amplify_outputs.json";
import type { Schema } from "~~/amplify/data/resource";
import { Amplify } from "aws-amplify";
import { getUrl } from "aws-amplify/storage";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito"
import { CookieStorage } from "aws-amplify/utils"

// configure the Amplify client library
Amplify.configure(outputs, { ssr: true });

const host = typeof window !== "undefined" ? window.location.hostname : "localhost"
const isLocalhost = host === "localhost"

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    path: "/",
    sameSite: "lax",
    // localhost must be insecure cookies on http
    secure: !isLocalhost,
    // DON'T set domain on localhost
    ...(isLocalhost ? {} : { domain: ".colibriocirrus.com" }),
    expires: 30,
  })
)


// generate your data client using the Schema from your backend
const client = generateClient<Schema>();

export default defineNuxtPlugin({
  name: "AmplifyAPIs",
  enforce: "pre",
  setup() {
    return {
      provide: {
        // You can call the API by via the composable `useNuxtApp()`. For example:
        // `useNuxtApp().$Amplify.Auth.fetchAuthSession()`
        Amplify: {
          Auth: {
            fetchAuthSession,
            fetchUserAttributes,
            getCurrentUser,
            signIn,
            signOut,
            signUp,
            confirmSignUp,
            resendSignUpCode
          },
          GraphQL: {
            client,
          },
          Storage: {
            getUrl
          }
        },
      },
    };
  },
});